import { useSelector } from 'react-redux';
import { getCreateEntityAccess } from 'store/authentication/selectors';
import RelationshipOneV2 from 'components/Fields/FieldInput/RelationshipOneV2';
import ContactSelector from 'components/Modals/ActivityCompletionModal/ContactSelector';
import {
  CONTACT_SELECTOR,
  CUSTOM_SELECTOR,
} from 'components/Charts/ScheduledActivities/assignmentHelpers';
import { AssociationFields, StyledLoader } from './styled';
import ChunkRender from 'components/ChunkRender';
import { useTranslation } from 'react-i18next';
import { useCompleteActivityWizardContext } from './context';

const KEY_LISTENER_DEFAULT = () => ({});

/**
 * @param {import('./context').CompleteActivityWizardContext} context
 * @param {*} relatedObject
 * @returns {boolean}
 */
const hasPredefinedOption = (context, relatedObject) => {
  if (relatedObject.name === 'client_client') {
    return Boolean(context.predefinedOptions?.clientOption);
  }

  return Boolean(
    context.predefinedOptions?.defaultAssignment?.[relatedObject.id]
  );
};

export const ActivityAssosiationFields = ({
  assignments,
  errors,
  getKeyListenersProps = KEY_LISTENER_DEFAULT,
  activityRelatedObjects,
  loading,
  handleChange,
}) => {
  const { t } = useTranslation();
  const createEntityAccess = useSelector(getCreateEntityAccess);
  const ctx = useCompleteActivityWizardContext();

  const { areDefaultAssignmentsFromScheduledActivity, isScheduledActivity } =
    ctx;

  return (
    <StyledLoader loading={loading}>
      <AssociationFields>
        <ChunkRender>
          {activityRelatedObjects.map((act, index) => {
            const { type, getterProp, setterProp, isReadonly, isRequired } =
              act.component;

            const value = assignments[getterProp];

            const readonly = !isScheduledActivity
              ? hasPredefinedOption(ctx, act)
                ? areDefaultAssignmentsFromScheduledActivity && isReadonly
                : isReadonly && !isRequired
              : false;

            const validate = {
              message: errors?.[index]?.message,
              showMessage: !!errors?.[index],
            };

            if (type === CUSTOM_SELECTOR) {
              return (
                <RelationshipOneV2
                  key={act.id}
                  {...getKeyListenersProps(act.id)}
                  disableTopMenuButton={!createEntityAccess[act.id]}
                  label={act.objectName || act.description || act.modelName}
                  field={act}
                  value={value}
                  error={validate.showMessage}
                  validate={validate}
                  isReadOnly={readonly}
                  required={isRequired}
                  onChange={handleChange(setterProp)}
                  margin
                  disabled={!act.access.edit || readonly}
                  labelInfo={
                    !act.access.edit
                      ? t(
                          'You do not have permission to this object. Please contact your administrator to increase your access level.'
                        )
                      : null
                  }
                />
              );
            }
            if (type === CONTACT_SELECTOR) {
              return (
                <ContactSelector
                  field={act}
                  key={act.id}
                  {...getKeyListenersProps(act.id)}
                  disableTopMenuButton={!createEntityAccess[act.id]}
                  label={act.objectName || act.description || act.modelName}
                  isReadOnly={readonly}
                  required={isRequired}
                  value={value}
                  error={validate.showMessage}
                  validate={validate}
                  onSetClientOption={handleChange(setterProp)}
                  disabled={!act.access.edit || readonly}
                  labelInfo={
                    !act.access.edit
                      ? t(
                          'You do not have permission to this object. Please contact your administrator to increase your access level.'
                        )
                      : null
                  }
                  margin
                />
              );
            }
            return null;
          })}
        </ChunkRender>
      </AssociationFields>
    </StyledLoader>
  );
};
